import { Fragment } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import moment from 'moment'
import Typography from 'beam/dist/Typography'
import Button from 'beam/dist/Button'
import Dialog, { DialogTitle, DialogContent, DialogContentText, DialogActions } from 'beam/dist/Dialog'

const AlertDialog = ({ alert, onDelete, onClose, t }) => (
  <Dialog open={Boolean(alert)} onClose={onClose}>
    <DialogTitle>{t('alertDetailsTitle')}</DialogTitle>
    <DialogContent>
      {alert ? (
        <Fragment>
          <Typography variant="subtitle1">{t('time')}</Typography>
          <DialogContentText>
            {moment(alert.timestamp).format(
              'MM/DD/YYYY hh:mma',
            ) /* TODO: timezones will be addressed in a separate story */}
          </DialogContentText>
          <Typography variant="subtitle1">{t('message')}</Typography>
          <DialogContentText className="prose-a:text-blue-600 prose" dangerouslySetInnerHTML={{ __html: alert.message }} />
        </Fragment>
      ) : (
        ''
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={onDelete} color="primary">
        {t('deleteLabel')}
      </Button>
      {/* eslint-disable-next-line jsx-a11y/no-autofocus -- TODO: remove this eslint-disable or replace this eslint-disable comment with a proper justification */}
      <Button onClick={onClose} color="primary" autoFocus>
        {t('close')}
      </Button>
    </DialogActions>
  </Dialog>
)

AlertDialog.propTypes = {
  alert: PropTypes.object,
  onDelete: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
}

AlertDialog.defaultProps = {
  alert: null,
}

export default withTranslation()(AlertDialog)
